import { getRouteIndex } from 'selectors';
import * as constants from 'constants';
import { ActionSheet, WebBrowser, FilePicker, MediaViewer, TelPicker } from 'core';

import { isWeb, isNative } from 'core';
export const SHOW_LOGIN = 'UI.SHOW_LOGIN';
export const SELECT_SETTINGS_ITEM = 'UI.SELECT_SETTINGS_ITEM';
export const OPEN_MODAL = 'UI.OPEN_MODAL';
export const SELECT_APP_TAB = 'UI.SELECT_APP_TAB';
export const SELECT_GROUP = 'UI.SELECT_GROUP';
export const SELECT_MEMBER = 'UI.SELECT_MEMBER';
export const SELECT_TASK = 'UI.SELECT_TASK';
export const SELECT_MSG = 'UI.SELECT_MSG';
export const SELECT_PM = 'UI.SELECT_PM';
export const SELECT_CONV_INFO = 'UI.SELECT_CONV_INFO';
export const SELECT_PM_INFO = 'UI.SELECT_PM_INFO';
export const SELECT_GROUP_TAB = 'UI.SELECT_GROUP_TAB';
export const BACK = 'UI.BACK';
export const NEXT = 'UI.NEXT';
export const LOAD_PREV_MESSAGES = 'UI.LOAD_PREV_MESSAGES';
export const LOAD_NEXT_MESSAGES = 'UI.LOAD_NEXT_MESSAGES';
export const SELECT_TMP_PM = 'UI.SELECT_TMP_PM';
export const REMOVE_TMP_PM = 'UI.REMOVE_TMP_PM';
export const JUMP_TO_CONV = 'UI.JUMP_TO_CONV';
export const REMOVE_SELECTED = 'UI.REMOVE_SELECTED';

export const showLogin = show_login => ({
  type: SHOW_LOGIN,
  payload: { show_login }
});
export const selectAppTab = selected_app_tab => ({
  type: SELECT_APP_TAB,
  payload: { selected_app_tab, route_index: isWeb ? getRouteIndex(selected_app_tab) : 0 }
});

export const selectGroup = selected_group => ({
  type: SELECT_GROUP,
  payload: { selected_group }
});

export const selectMember = member_id => ({
  type: SELECT_MEMBER,
  payload: { selected_member: member_id }
});

export const selectTask = selected_task => ({
  type: SELECT_TASK,
  payload: { selected_task }
});

export const selectMsg = selected_msg => ({
  type: SELECT_MSG,
  payload: { selected_msg }
});

export const selectPM = selected_pm => ({
  type: SELECT_PM,
  payload: { selected_pm }
});

export const openModal = modal_name => ({
  type: OPEN_MODAL,
  payload: { modal_name }
});

export const closeModal = () => ({
  type: OPEN_MODAL,
  payload: { modal_name: '' }
});

export const selectGroupTab = selected_group_tab => ({
  type: SELECT_GROUP_TAB,
  payload: { selected_group_tab }
});

export const selectSettingsItem = selected_settings_item => ({
  type: SELECT_SETTINGS_ITEM,
  payload: { selected_settings_item, route_index: 1 }
});

export const selectTmpPM = (id, name, photo) => (dispatch, getState) => {
  const user_id = getState().user.id;
  let payload = {
    selected_pm: [user_id, id].sort().join(''),
    tmp_pm: {
      id,
      name,
      photo
    }
  };
  isWeb && (payload.selected_app_tab = constants.APP_TABS.PM);
  dispatch({
    type: SELECT_TMP_PM,
    payload
  });
};

export const removeTmpPM = () => ({
  type: REMOVE_TMP_PM,
  payload: {
    tmp_pm: null
  }
});

export const goBack = index => (dispatch, getState) => {
  const route_index = index === true ? 0 : index || getState().ui.route_index - 1;
  const nullify = isNative ? nativeTransEnd(route_index) : {};
  dispatch({
    type: BACK,
    payload: { ...nullify, route_index }
  });
};

export const goNext = index => (dispatch, getState) => {
  dispatch({
    type: NEXT,
    payload: { route_index: index || getState().ui.route_index + 1 }
  });
};

export const getPrevMessages = conv_id => ({ type: LOAD_PREV_MESSAGES, payload: { loading_prev_messages: conv_id } });

export const getNextMessages = conv_id => ({ type: LOAD_NEXT_MESSAGES, payload: { loading_next_messages: conv_id } });

export const jumpToConvReset = () => ({
  type: JUMP_TO_CONV,
  payload: {
    jump_to_conv: null
  }
});

export const closeProviders = () => {
  FilePicker.close();
  MediaViewer.close();
  TelPicker.close();
  WebBrowser.close();
  ActionSheet.close();
};

export const jumpToConv = conv => (dispatch, getState) =>
  dispatch({
    type: JUMP_TO_CONV,
    payload: {
      route_index: 1,
      selected_app_tab: conv.type === 'PM' ? constants.APP_TABS.PM : constants.APP_TABS.GROUPS,
      selected_settings_item: null,
      tmp_pm: null,
      modal_name: '',
      selected_pm: conv.type === 'PM' ? conv.id : null,
      selected_group: conv.type === 'PM' ? null : conv.id,
      jump_to_conv: conv.id
    }
  });

export const nativeTransEnd = index => {
  let payload = {};
  switch (index) {
    case 0:
      payload = { selected_pm: null, selected_group: null, selected_settings_item: null, tmp_pm: null };
      break;
    case 1:
      payload = { tmp_pm: null };
      break;
    case 2:
      payload = { tmp_pm: null };
      break;
    case 3:
      break;
    case 4:
      break;
    default:
      console.log('nativeTransEnd: should not reach here', index);
  }
  return payload;
};



// WEBPACK FOOTER //
// ./src/actions/ui.js